// Booking-related mock data

export const timeSlots = [
  { value: '09:00', label: '9:00 AM' },
  { value: '10:00', label: '10:00 AM' },
  { value: '11:00', label: '11:00 AM' },
  { value: '12:00', label: '12:00 PM' },
  { value: '13:00', label: '1:00 PM' },
  { value: '14:00', label: '2:00 PM' },
  { value: '15:00', label: '3:00 PM' },
  { value: '16:00', label: '4:00 PM' },
  { value: '17:00', label: '5:00 PM' },
  { value: '18:00', label: '6:00 PM' }
];

export const serviceDurations = {
  // Auto Detailing packages (id: 1)
  'detailing-basic-wash-&-vac': { hours: 2, name: 'Auto Detailing - Basic Wash & Vac' },
  'detailing-interior-detail': { hours: 3, name: 'Auto Detailing - Interior Detail' },
  'detailing-exterior-detail': { hours: 3, name: 'Auto Detailing - Exterior Detail' },
  'detailing-full-detail': { hours: 5, name: 'Auto Detailing - Full Detail' },
  'detailing-paint-correction-(1-stage)': { hours: 8, name: 'Auto Detailing - Paint Correction (1-stage)' },
  'detailing-paint-correction-(2-stage)': { hours: 16, name: 'Auto Detailing - Paint Correction (2-stage)' },
  
  // Ceramic Coating packages (id: 2)
  'ceramic-coating-bronze-(entry)': { hours: 8, name: 'Ceramic Coating - Bronze (Entry)' },
  'ceramic-coating-silver-(standard)': { hours: 12, name: 'Ceramic Coating - Silver (Standard)' },
  'ceramic-coating-gold-(premium)': { hours: 20, name: 'Ceramic Coating - Gold (Premium)' },
  'ceramic-coating-maintenance-wash': { hours: 1, name: 'Ceramic Coating - Maintenance Wash' },
  
  // PPF packages (id: 3)
  'ppf-partial-front': { hours: 5, name: 'PPF - Partial Front' },
  'ppf-full-front': { hours: 12, name: 'PPF - Full Front' },
  'ppf-track-pack': { hours: 20, name: 'PPF - Track Pack' },
  'ppf-full-body': { hours: 48, name: 'PPF - Full Body' },
  
  // Vinyl Wraps packages (id: 4)
  'vinyl-wraps-full-colour-change-(sedan)': { hours: 32, name: 'Vinyl Wraps - Full Colour Change (Sedan)' },
  'vinyl-wraps-full-colour-change-(suv/truck)': { hours: 40, name: 'Vinyl Wraps - Full Colour Change (SUV/Truck)' },
  'vinyl-wraps-specialty-finish': { hours: 48, name: 'Vinyl Wraps - Specialty Finish' },
  'vinyl-wraps-partial/accents': { hours: 12, name: 'Vinyl Wraps - Partial/Accents' },
  'vinyl-wraps-commercial/fleet': { hours: 16, name: 'Vinyl Wraps - Commercial/Fleet' },
  
  // Window Tinting packages (id: 5)
  'tinting-dyed-film': { hours: 3, name: 'Window Tinting - Dyed Film' },
  'tinting-carbon-film': { hours: 4, name: 'Window Tinting - Carbon Film' },
  'tinting-ceramic-film': { hours: 4, name: 'Window Tinting - Ceramic Film' },
  'tinting-windshield-strip': { hours: 1, name: 'Window Tinting - Windshield Strip' },
  
  // CarPlay packages (id: 6)
  'carplay-wired-carplay-retrofit': { hours: 3, name: 'CarPlay - Wired CarPlay Retrofit' },
  'carplay-wireless-carplay-upgrade': { hours: 2, name: 'CarPlay - Wireless CarPlay Upgrade' },
  'carplay-full-infotainment-system': { hours: 5, name: 'CarPlay - Full Infotainment System' },
  
  // Vehicle Gadgets & Accessories packages (id: 7)
  'gadgets-dash-cam-(front)': { hours: 2, name: 'Gadgets - Dash Cam (Front)' },
  'gadgets-dash-cam-(front-+-rear)': { hours: 3, name: 'Gadgets - Dash Cam (Front + Rear)' },
  'gadgets-speaker-upgrade': { hours: 3, name: 'Gadgets - Speaker Upgrade' },
  'gadgets-subwoofer-&-amplifier': { hours: 4, name: 'Gadgets - Subwoofer & Amplifier' },
  'gadgets-wheel-packages': { hours: 2, name: 'Gadgets - Wheel Packages' },
  'gadgets-led-lighting': { hours: 2, name: 'Gadgets - LED Lighting' }
};

// Mock existing bookings for availability checking
export const mockBookings = [
  {
    id: 1,
    date: new Date(2026, 0, 7).toISOString().split('T')[0], // Jan 7, 2026
    time: '10:00',
    service: 'detailing-premium',
    customerName: 'John Doe'
  },
  {
    id: 2,
    date: new Date(2026, 0, 7).toISOString().split('T')[0],
    time: '14:00',
    service: 'tinting-standard',
    customerName: 'Jane Smith'
  }
];

// Check if a time slot is available
export const isTimeSlotAvailable = (date, time, serviceDuration) => {
  const dateStr = date.toISOString().split('T')[0];
  const duration = serviceDurations[serviceDuration]?.hours || 2;
  
  // Check if slot conflicts with existing bookings
  const conflictingBookings = mockBookings.filter(booking => {
    if (booking.date !== dateStr) return false;
    
    const bookingTime = parseInt(booking.time.split(':')[0]);
    const bookingDuration = serviceDurations[booking.service]?.hours || 2;
    const requestedTime = parseInt(time.split(':')[0]);
    
    // Check for overlap
    const bookingEnd = bookingTime + bookingDuration;
    const requestedEnd = requestedTime + duration;
    
    return (
      (requestedTime >= bookingTime && requestedTime < bookingEnd) ||
      (requestedEnd > bookingTime && requestedEnd <= bookingEnd) ||
      (requestedTime <= bookingTime && requestedEnd >= bookingEnd)
    );
  });
  
  // Allow max 2 concurrent bookings
  return conflictingBookings.length < 2;
};

// Submit booking (mock)
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Booking submission (MOCKED):', bookingData);
      
      // Add to mock bookings
      const newBooking = {
        id: mockBookings.length + 1,
        date: bookingData.date.toISOString().split('T')[0],
        time: bookingData.time,
        service: bookingData.service,
        customerName: bookingData.name
      };
      mockBookings.push(newBooking);
      
      // Save to localStorage
      localStorage.setItem('lastBooking', JSON.stringify({
        ...bookingData,
        bookingId: newBooking.id,
        timestamp: new Date().toISOString()
      }));
      
      resolve({
        success: true,
        bookingId: newBooking.id,
        message: 'Your appointment has been successfully booked!',
        mockNote: 'This is currently using mock data. Backend integration pending.'
      });
    }, 1000);
  });
};

// Get available time slots for a specific date and service
export const getAvailableSlots = (date, serviceDuration) => {
  const dayOfWeek = date.getDay();
  
  // Business hours based on day
  let availableSlots = [...timeSlots];
  
  // Sunday: 10 AM - 5 PM
  if (dayOfWeek === 0) {
    availableSlots = timeSlots.filter(slot => {
      const hour = parseInt(slot.value.split(':')[0]);
      return hour >= 10 && hour <= 16;
    });
  }
  
  // Saturday: 9 AM - 6 PM
  if (dayOfWeek === 6) {
    availableSlots = timeSlots.filter(slot => {
      const hour = parseInt(slot.value.split(':')[0]);
      return hour >= 9 && hour <= 17;
    });
  }
  
  // Filter based on availability
  return availableSlots.filter(slot => 
    isTimeSlotAvailable(date, slot.value, serviceDuration)
  );
};
